module.exports = __webpack_public_path__ + "static/media/susana.4fe9d274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/susana.png
// module id = 347
// module chunks = 0